import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHook";
import { setFilters } from "../../reducers/catalogFilterSlice";
import { CatalogFilterState } from "../../types";

/** Dispatch `setFilters({ [key]: values })` exactly once, when data first becomes available. */
export function useSeedFilter(
  values: string[],
  isLoading: boolean,
  filterKey: keyof Pick<CatalogFilterState, "devices" | "trapsites">,
) {
  const dispatch = useAppDispatch();

  const flagKeyMap = {
    devices: "hasSeededDevices",
    trapsites: "hasSeededTrapsites",
  } as const;
  const flagKey = flagKeyMap[filterKey];
  const hasSeeded = useAppSelector((state) => state.catalogFilter[flagKey]);

  useEffect(() => {
    if (!hasSeeded && !isLoading) {
      dispatch(setFilters({ [filterKey]: values, [flagKey]: true }));
    }
  }, [values, isLoading, dispatch, filterKey, hasSeeded, flagKey]);
}
